module.exports = __webpack_public_path__ + "static/media/banner_img.d02a4c93.webp";